module.exports = __webpack_public_path__ + "img/Christmas-text.071799ba.jpg";